/** 2023-08-25 scrollTop.ts - 온클릭 핸들러 / 최상단으로 이동 */
const scrollTop = (): void => {
  window.scrollTo(0, 0);
};

export default scrollTop;
